// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1L4lA","row":"Node_row__GmaHW","label":"Node_label__BPNG8","footer":"Node_footer__1c_ZW"};